import React from 'react';

import './LoginPage.css';
import LoginForm from './components/LoginForm.tsx';
import logo from '@/src/assets/images/Paradigm-Math-logo-dark.png';

const LoginPage: React.FC = () => {
    document.title = 'Paradigm Login';

    return (
        <div className="login-bg">
            <div className="login-box">
                <img
                    style={{
                        maxWidth: '250px',
                        height: 'auto',
                        width: '100%',
                        objectFit: 'contain',
                    }}
                    src={logo}
                    alt="Paradigm Math Logo"
                    className="login-logo"
                />
                <br />
                <LoginForm />
            </div>
        </div>
    );
};

export default LoginPage;
